import React from 'react';
import { connect } from 'react-redux';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';
import InputField from '@synergycms_core/components/generic/Form/InputField.jsx';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import { RichText } from '@synergycms_core/components/generic/';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';


import { FIDELTOUR_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import LoyaltyFormLogin from './LoyaltyFormLogin';


const LoyaltyForm = class LoyaltyForm extends React.Component {
  static displayName = 'LoyaltyForm';

  constructor(props) {
    super(props);
    this.state = {
      alreadyMember: false
    }
  }

  toggleMember = () => {
    this.setState({ alreadyMember: !this.state.alreadyMember });
  }

  render() {
    const { config } = this.props;
    const { loyaltyUser, loyaltySelected, loyaltyType, classes, isLoyaltyPrice } = config;

    const enableToggleForm = !!loyaltyUser;
    const showEditUserFields = !enableToggleForm;
    
    if (FIDELTOUR_CODE === loyaltyType && !!loyaltySelected && isLoyaltyPrice && !loyaltyUser) {
      return (
        <div
          className={[classes.membersOnlyContainer].join(' ')}>
          <RichText
            text={'_%Programa Members Only%_'}
            translate={true}
            ucFirst={false}
            innerStyle={['roboto16BoldBlack']}
          />
          <label className={[classes.checkBox, classes.membersCheckBox].join(' ')} onChange={this.toggleMember}>
            <CheckboxField
              defaultValue={this.state.alreadyMember}
              type={'checkbox'}
              model={'already_member'}
              innerStyle={['inputCheck', classes.inputCheck]}
            />
            <RichText
              translate={true}
              ucFirst={true}
              innerStyle={['roboto13Black']}
              text={'_%Ya soy miembro%_'}
            />
          </label>

          {this.state.alreadyMember ? (
            <LoyaltyFormLogin customerForm={true} classes={classes} />
          ) : (
            <>
              <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMarginNo, classes.memberPass].join(' ')} useref={'password'}>
                <InputField
                  model={'password'}
                  type={'password'}
                  innerStyle={['inputText', 'roboto16BlackModified', classes.inputText]}
                  validationsFields={{ field: 'contraseña' }}
                  validations={[
                    'required',
                    {
                      type: 'maxLength',
                      maxLength: 16
                    },
                    {
                      type: 'minLength',
                      minLength: 8
                    },
                    {
                      type: 'compareField',
                      invalidText: '',
                      alterModel: 'repeatPassword',
                      alterField: 'repetir password'
                    }
                  ]} />
                <InputNotify model={'password'} />
                <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%contraseña fidelizacion%_'}
                          translate={true} />
              </label>
              <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMarginNo].join(' ')} useref={'repeatPassword'}>
                <InputField
                  model={'repeatPassword'}
                  type={'password'}
                  innerStyle={['inputText', 'roboto16BlackModified', classes.inputText]}
                  validationsFields={{ field: 'repetir password' }}
                  validations={['required', { type: 'maxLength', maxLength: 16 }, {
                    type: 'minLength',
                    minLength: 8
                  }, {
                    type: 'compareField',
                    alterModel: 'password',
                    alterField: 'password'
                  }]} />
                <InputNotify model={'repeatPassword'} />
                <RichText innerStyle={[classes.labelText]} ucFirst={true} text={'_%repetir contrasena fidelizacion%_'} translate={true} />
               </label>
            </>
          )}
        </div>
      );
    } else return null;
  };
};


const mapStateToProps = (store) => {
  const reservation = store.getIn(['customer', 'reservation']);
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const loyaltyType = store.getIn(['customer', 'loyalty', 'data', 'loyalty', 'code'], null);

  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );


  const roomRatesSelected = store.getIn(['customer', 'reservation_request']);
  const loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'string_loyalty_query_params']),
    'response'
  ],false);

  let loyaltySelected = !!loyaltyRoomsAvail && roomRatesSelected.get('loyalty', false);
  let loyaltyUser = store.getIn(['customer', 'loyalty','user',"user_id"], null) && store.getIn(['customer', 'loyalty','user'], null);
  return {
    loyaltyUser: loyaltyUser,
    loyaltySelected: loyaltySelected,
    loyaltyType,
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    isLoyaltyPrice: !!reservation.getIn(['loyalty'], ((FIDELTOUR_CODE === loyaltyType || !loyaltySelected)))
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(mapStateToProps),
  //withThemeJSS(),
  PropertyManager([
    "classes", "loyaltyType", "loyaltyUser", "loyaltySelected", "profileType", "reservation","hotel", "isLoyaltyPrice"
  ])
)(LoyaltyForm);
